/* ============================================================
   LÉO NOMADE × MAROC — réservation (vraies variantes Shopify)
   + header sticky + sold-out modal/waitlist + reveal.
   Variantes injectées par dm-ln-reservation (#ln-variant-data).
   ============================================================ */
(function () {
  'use strict';

  function euro(n, decimals) {
    return n.toLocaleString('fr-FR', {
      minimumFractionDigits: decimals ? 2 : 0,
      maximumFractionDigits: decimals ? 2 : 0
    }) + ' €';
  }

  /* --- sticky header (translucide après le hero) --- */
  function setupHeader() {
    var header = document.getElementById('ln-header');
    var hero = document.getElementById('top');
    if (!header) return;
    var update = function () {
      var threshold = hero ? hero.offsetHeight * 0.82 : window.innerHeight * 0.8;
      header.classList.toggle('is-stuck', window.scrollY > threshold);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* --- reveal on scroll --- */
  function setupReveal() {
    var els = document.querySelectorAll('.dm-ln .reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  /* --- waitlist forms (sold-out) --- */
  function setupWaitlist() {
    var forms = document.querySelectorAll('.ln-wl form');
    Array.prototype.forEach.call(forms, function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.querySelector('input[type="email"]');
        if (email && !email.checkValidity()) { email.reportValidity(); return; }
        try { localStorage.setItem('ln_waitlist_' + window.location.pathname, '1'); } catch (e2) {}
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = '…'; }
        function done() {
          var ok = form.querySelector('.ln-modal__ok');
          var row = form.querySelector('.ln-modal__row');
          if (row) row.style.display = 'none';
          if (ok) ok.hidden = false;
        }
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
          .then(done).catch(done);
      });
    });
  }

  /* --- sold-out modal --- */
  function setupModal() {
    var modal = document.getElementById('lnSoldoutModal');
    if (!modal) return;
    function open() { modal.hidden = false; modal.classList.add('is-open'); }
    function close() { modal.classList.remove('is-open'); setTimeout(function () { modal.hidden = true; }, 200); }
    Array.prototype.forEach.call(modal.querySelectorAll('[data-close]'), function (el) {
      el.addEventListener('click', close);
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
    var done = false;
    try { done = localStorage.getItem('ln_waitlist_' + window.location.pathname) === '1'; } catch (e) {}
    if (!done) setTimeout(open, 700);
  }

  /* --- réservation : sélection formule câblée aux variantes --- */
  function setupBooking() {
    var widget = document.getElementById('ln-widget');
    if (!widget) return;

    var variants = [];
    var dataEl = document.getElementById('ln-variant-data');
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; } }

    var totalEl   = document.getElementById('ln-total');
    var depositEl = document.getElementById('ln-deposit');
    var cta       = document.getElementById('ln-book-cta');
    var form      = document.getElementById('ln-product-form');
    var hidden    = form ? form.querySelector('[data-variant-id]') : null;
    var cards     = Array.prototype.slice.call(widget.querySelectorAll('.ln-formula'));
    var selectedId = null;

    function variantById(id) {
      for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(id)) return variants[i]; }
      return null;
    }

    function select(id) {
      var v = variantById(id);
      if (!v) return;
      selectedId = v.id;
      cards.forEach(function (c) { c.classList.toggle('is-active', String(c.getAttribute('data-vid')) === String(id)); });
      if (hidden) hidden.value = v.id;
      var total   = (v.compare || v.price) / 100;
      var deposit = v.price / 100;
      if (totalEl)   totalEl.textContent   = euro(total, false);
      if (depositEl) depositEl.textContent = euro(deposit, true);
      if (cta) {
        if (v.available === false) {
          cta.textContent = 'Complet'; cta.classList.add('is-disabled'); cta.setAttribute('aria-disabled', 'true');
        } else {
          cta.textContent = 'Réserve ta place'; cta.classList.remove('is-disabled'); cta.removeAttribute('aria-disabled');
        }
      }
    }

    cards.forEach(function (c) {
      c.addEventListener('click', function () { select(c.getAttribute('data-vid')); });
    });

    // prix de chaque carte au même format que le total (« 1 399 € »)
    cards.forEach(function (c) {
      var v = variantById(c.getAttribute('data-vid'));
      var pe = c.querySelector('.ln-formula__price');
      if (v && pe) pe.textContent = euro((v.compare || v.price) / 100, false);
    });

    // sélection initiale : 1re carte (Sans vol)
    if (cards.length) select(cards[0].getAttribute('data-vid'));

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = variantById(selectedId);
        if (v && v.available === false) return;
        if (hidden && selectedId) hidden.value = selectedId;
        if (cta) { cta.classList.add('is-disabled'); cta.textContent = 'Ajout en cours…'; }
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error('add_failed'); return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { form.submit(); });
      });
    }
  }

  /* --- smooth scroll ancres internes (durée contrôlée, offset header) --- */
  function setupSmoothScroll() {
    var header = document.getElementById('ln-header');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
    function scrollTo(to, dur) {
      var start = window.pageYOffset, change = to - start, t0 = null;
      if (reduce) { window.scrollTo(0, to); return; }
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        window.scrollTo(0, start + change * ease(p));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var links = document.querySelectorAll('.dm-ln a[href^="#"]');
    Array.prototype.forEach.call(links, function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        if (!id || id.length < 2) return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        var offset = (header ? header.offsetHeight : 0) + 10;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        scrollTo(top, 820);
      });
    });
  }

  function init() {
    try { localStorage.setItem('dm_return_url', window.location.pathname); } catch (e) {}
    setupHeader();
    setupReveal();
    setupWaitlist();
    setupModal();
    setupBooking();
    setupSmoothScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
